import WebSocketContext from './context';

const useWebSocket = () => WebSocketContext.hook();

export default useWebSocket;
